/*
 * @Descripttion:
 * @Author: voanit
 * @Date: 2023-01-20 09:41:40
 * @LastEditors: voanit
 * @LastEditTime: 2023-11-20 11:12:24
 */
import axios from 'axios'
import qs from "qs";
import { Loading } from 'element-ui';

/****** 创建axios实例 ******/
const service = axios.create({
  baseURL: 'https://uniapp.boyuancb.com/api',
  // withCredentials: true, // send cookies when cross-domain requests
})

let loadingInstance,loadingCount = 0 //申明loading

/****** request拦截器==>对请求参数做处理 ******/
service.interceptors.response.use(config => {
      // console.log("打开前"+loadingCount)
      if (loadingCount == 0) {
          // console.log("有loading了")
          // console.log("打开时"+loadingCount)
          loadingInstance = Loading.service({
              lock: true,
              customClass: "z-index999",
              text: "数据加载中，请稍后...",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
          })
      }
      loadingCount++
      config.method === 'post'? config.data = qs.stringify({...config.data}): config.params = {...config.params};
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      return config;
  },
  error => {
    // loadingCount--
    // if (loadingInstance && loadingCount==0) {
    //     loadingInstance.close()
    // }
    return Promise.reject(error)
  }
)

/****** respone拦截器==>对响应做处理 ******/
service.interceptors.response.use(
    response => {  //成功请求到数据
        loadingCount--
        // console.log("关闭时的"+loadingCount)
        if (loadingInstance && loadingCount == 0) {
            loadingInstance.close()
        }
        //这里根据后端提供的数据进行对应的处理
        switch (response.status) {
            case 200:
                return response.data;
                break
            case 205:
                return Promise.resolve({ code: response.status, message: '没有值' })
                break
            case 500:
                return Promise.resolve({ code: response.status, message: '未知错误' })
                break
            default:
                return Promise.resolve({ status: response.status, message: '未知错误' })
                break
        }
    },
    error => {  //响应错误处理
      // loadingCount--
      // if (loadingInstance && loadingCount == 0) {
      //     loadingInstance.close()
      // }
      console.warn(`timeout of ${axios_defaults_timeout}ms exceeded`);
      return Promise.reject(error)
    }
);

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js